import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const REF_KEY = "nw_ref";

export const getStoredRef = () => {
  try { return localStorage.getItem(REF_KEY) || ""; } catch { return ""; }
};

/** Captures ?ref=CODE from any landing URL and persists it for signup. */
const RefCapture = () => {
  const location = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const ref = params.get("ref");
    if (ref) {
      try { localStorage.setItem(REF_KEY, ref.trim().toUpperCase()); } catch { /* noop */ }
    }
  }, [location.search]);
  return null;
};

export default RefCapture;
